import React, { useEffect, useState } from "react";

import {useManageGetRequest} from "../../../../../hooks/useManageGetRequest/useManageGetRequest";

import {
    cuadroRequerimientosGetRatiosHistoricoAPI,
} from '../../../../../consumers/backendApisUrls';

import styled from "styled-components";

const Container = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 16px;
  max-width: 720px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

const Thead = styled.thead`
  background-color: #f5f6f8;
`;

const Th = styled.th`
  padding: 10px;
  text-align: center;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #d1d5db;
  white-space: nowrap;
`;

const ThLeft = styled(Th)`
  text-align: left;
`;

const Tr = styled.tr`
  border-bottom: 1px solid #e5e7eb;
`;

const Td = styled.td`
  padding: 8px 10px;
  text-align: center;
  color: #333;
`;

const TdLeft = styled(Td)`
  text-align: left;
  font-weight: 500;
`;

const SubNote = styled.div`
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
`;
 
export default function CuadroRequerimientosKpisHistoricosTab({ idCuadroSede }) {

    const [data, setData] = useState([]);
    const [years, setYears] = useState([]);

    useEffect(() => {
        setYears(data.map(item => item.AnioCampana));
    }, [data]);

    const KPI_CONFIG = [
        {
            label: 'Ratio',
            field: 'Ratio',
            subnote: null
        },
        {
            label: 'Promedio bloques profesor/a',
            field: 'PromedioBloquesPorProfesor',
            subnote: '(sin inicial, unidocencia, EEFF, artes, temporales, volantes ni excedentes)'
        }
    ];
        const [executeManageGet] = useManageGetRequest();

        const getData = async () => {
            const api = cuadroRequerimientosGetRatiosHistoricoAPI(idCuadroSede);
            await executeManageGet(api, ({ data }) => getDataCallBack(data), false);
        }
    
        const getDataCallBack = async (data) => {
            setData(data);
        };
    
        const getInitData = async () => {
            getData();        
        }
    
        const init = async () => { 
            getInitData();
        };
    
        useEffect(() => {
            init(); 
        }, []);

    return (
        <Container>
            <Table>
                <Thead>
                    <Tr>
                        <ThLeft>Datos Anuales</ThLeft>
                        {years.map((year, index) => (
                            <Th key={index}>{year}</Th>
                        ))}
                    </Tr>
                </Thead>

                <tbody>
                {KPI_CONFIG.map((kpi, index) => (
                    <Tr key={index}>
                        <TdLeft>
                            {kpi.label}
                            {kpi.subnote && (
                                <div style={{ fontSize: '0.8em', color: '#666', fontWeight: 'normal' }}>
                                    {kpi.subnote}
                                </div>
                            )}
                        </TdLeft>
                        {data.map((item, i) => (
                            <Td key={i}>
                                {item[kpi.field]}
                            </Td>
                        ))}
                    </Tr>
                ))}
                </tbody>
            </Table>
        </Container>
    );
}
